module.exports = __webpack_public_path__ + "static/img/s10.3f25a51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s10.png
// module id = hoWe
// module chunks = 0